import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import 'Components/OnSale/SummerSale.scss';

import Meta from 'Components/Utility/SEO/Meta';
import { fetchTopSellersSection } from 'Redux/ducks/algolia-calls';
import HitCard from 'Components/Cards/HitCard';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';
import imgixConfig from 'Config/imgix';

const messages = defineMessages({
  title: {
    id: 'summer-sale.seotitle',
    defaultMessage: 'PC Game Deals - Games & Steam Keys On Sale',
  },
  desc: {
    id: 'summer-sale.seodesc',
    defaultMessage: 'Top Sellers on great PC, Mac, and Linux games from over 750 top publishers. Whether you\'re looking for the latest, greatest games, or one of our exclusive bundles, we are Fanatical about always bringing you the best deals on the planet.',
  },
});

const SummerSaleContainer = ({ intl }) => {
  const { formatMessage } = intl;
  const [hasLoaded, setHasLoaded] = useState(false);
  const [topSellers, setTopSellers] = useState([]);

  useEffect(() => {
    const loadPosts = async () => {
      setHasLoaded(true);
      const fetchedHits = await fetchTopSellersSection(12);
      return setTopSellers(fetchedHits);
    };

    if (!hasLoaded) {
      loadPosts();
    }
  }, [hasLoaded]);

  const bgImgSrc = 'https://fanatical.imgix.net/production/assets/summer-sale/SS22-takeover2-5000x600.png';

  return (
    /* eslint-disable max-len */
    <div className="summer-sale-page">
      <Meta
        title={formatMessage(messages.title)}
        description={formatMessage(messages.desc)}
        url="on-sale"
        pageType="CollectionPage"
      />
      <header className="solid-hero-container summer-sale d-block">
        <div className="hero-background-container">
          <img
            srcSet={`
              ${bgImgSrc}?${imgixConfig}&w=5000&h=800&fit=crop 5000w,
              ${bgImgSrc}?${imgixConfig}&w=4250&h=680&fit=crop 4250w,
              ${bgImgSrc}?${imgixConfig}&w=3600&h=576&fit=crop 3600w,
              ${bgImgSrc}?${imgixConfig}&w=2500&h=400&fit=crop 2500w,
              ${bgImgSrc}?${imgixConfig}&w=1800&h=288&fit=crop 1800w,
              ${bgImgSrc}?${imgixConfig}&w=1520&h=243&fit=crop 1520w,
              ${bgImgSrc}?${imgixConfig}&w=1200&h=192&fit=crop 1200w,
              ${bgImgSrc}?${imgixConfig}&w=992&h=159&fit=crop 992w
            `}
            sizes="100vw"
            src={`${bgImgSrc}?${imgixConfig}&w=1800&h=288&fit=crop`}
            alt="Summer sale"
            className="hero-background"
          />
        </div>
      </header>

      <div className="container">
        <div className="rewards-header-section">
          <h1 className="pt-5 pb-3 rewards-header-title">
            <FormattedMessage id="summer-sale.header.ended" defaultMessage="Summer Sale Has Now Ended" />
          </h1>
          <p className="review-header-text">
            <FormattedMessage
              id="summer-sale.header.text.ended"
              defaultMessage="Sorry, the Summer Sale has now ended. If you have earned Rewards, they will be sent to you by email before August 23rd 2022. If you have any issues finding your rewards, please contact Support."
            />
          </p>
        </div>
      </div>

      <div className="bottom-section-container mt-6">
        <div className="relative-container container">
          <section className="topsellers-section">
            <h2 className="h1 topsellers-title">
              <FormattedMessage id="summer-sale.summersale" defaultMessage="Top Sellers" />
            </h2>

            {isEmpty(topSellers) &&
              <div className="row">
                <SkeletonHitCard
                  numberOfCards={12}
                  xsSize={12}
                  smSize={6}
                  mdSize={6}
                  lgSize={4}
                />
              </div>
            }

            {!isEmpty(topSellers) &&
              <div className="row">
                {topSellers.map(hit =>
                  <HitCard
                    hitCardLightTheme
                    key={hit.objectID}
                    hit={hit}
                  />,
                )}
              </div>
            }
          </section>
        </div>
        <img className="summer-sale-circle" src="https://fanatical.imgix.net/production/assets/summer-sale/summer-sale-circle.png" alt="Summer Sale Circle" />
      </div>
    </div>
  );
};

export default injectIntl(SummerSaleContainer);
